import { useState, useEffect } from "react";
import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

export const useHunterFarmerList = () => {
    const [hunterList, setHunterList] = useState([]);
    const [farmerList, setFarmerList] = useState([]);
    const [activeHunterList, setActiveHunterList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // All hunters
                const resultHunter = await apiRequest(
                    `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.AUTH.HUNTER_LIST}`,
                    "GET"
                );
                if (resultHunter) {
                    setHunterList(resultHunter);
                }

                // All farmers
                const resultFarmer = await apiRequest(
                    `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.AUTH.FARMER_LIST}`,
                    "GET"
                );
                if (resultFarmer) {
                    setFarmerList(resultFarmer);
                }

                // Active hunters from lead_gen_table
                const resultActiveHunter = await apiRequest(
                    `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.AUTH.ACTIVE_HUNTER_LIST}`,
                    "GET"
                );
                if (resultActiveHunter) {
                    setActiveHunterList(resultActiveHunter);
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    return {
        hunterListAPI: hunterList,
        farmerListAPI: farmerList,
        activeHunterListAPI: activeHunterList,
    };
};